const MIN_QUERY_LENGTH = 2;

const initBlogSearch = () => {
  const input = document.querySelector('[data-blog-search-input]');
  const searchBtn = document.querySelector('[data-blog-search-btn]');
  const banner = document.querySelector('[data-blog-search-banner]');
  const termEl = document.querySelector('[data-blog-search-term]');
  const articlesGrid = document.querySelector('[data-blog-articles-grid]');
  const resultsGrid = document.querySelector('[data-blog-search-results]');
  const dataEl = document.getElementById('blog-articles-data');

  if (!input || !articlesGrid || !resultsGrid || !dataEl) return;

  let articles = [];
  try {
    articles = JSON.parse(dataEl.textContent);
  } catch {
    return;
  }

  const showAll = () => {
    articlesGrid.classList.remove('hidden');
    resultsGrid.classList.add('hidden');
    resultsGrid.style.display = '';
    resultsGrid.innerHTML = '';
    banner?.classList.add('hidden');
  };

  const renderArticle = ({ title, url, image }) => {
    const img = image
      ? `<img src="${image}" alt="${title}" class="w-full aspect-29/36 object-cover" loading="lazy">`
      : '<div class="w-full aspect-29/36 bg-lighthouse"></div>';
    return `<a class="flex flex-col gap-3" href="${url}">${img}<h3 class="text-sm font-medium leading-snug">${title}</h3></a>`;
  };

  const showResults = (matches, query) => {
    articlesGrid.classList.add('hidden');
    resultsGrid.innerHTML = matches.length
      ? matches.map(renderArticle).join('')
      : `<p class="col-span-2 lg:col-span-4 text-sm text-dark-grey">No articles found for &ldquo;${query}&rdquo;.</p>`;
    resultsGrid.classList.remove('hidden');
    resultsGrid.style.display = 'grid';
    if (termEl) termEl.textContent = query;
    banner?.classList.remove('hidden');
  };

  const search = (query) => {
    const term = query.toLowerCase();
    const matches = articles.filter(({ title }) => title.toLowerCase().includes(term));
    showResults(matches, query);
  };

  const triggerSearch = () => {
    const value = input.value.trim();
    if (value.length < MIN_QUERY_LENGTH) { showAll(); return; }
    search(value);
  };

  input.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    triggerSearch();
  });

  searchBtn?.addEventListener('click', triggerSearch);

  input.addEventListener('input', () => {
    if (input.value.trim().length === 0) showAll();
  });
};

export default initBlogSearch;
